import { call, takeLatest, put, all } from 'redux-saga/effects';

import {
	getAccountMappingDetailsService,
	updateAccountMappingDetailsService,
} from './account-mapping.service';
import {
	// FETCH ACCOUNT MAP DETAILS
	getAccountMapDetailsSuccess,
	getAccountMapDetailsFailure,
	getAccountMapDetailsResponseChanged,
	// UPDATE ACCOUNT MAP DETAILS
	updateAccountMapDetailsSuccess,
	updateAccountMapDetailsFailure,
	updateAccountMapDetailsResponseChanged,
} from './account-mapping.action';
import AccountMapActionTypes from './account-mapping.types';
import { encryptData } from '../../../_common/enode-decode';

import AlertManager from '../../../../utils/alertManager';
/** ***************** GET ACCOUNT MAPPING DETAILS START *********************** */
export function* getAccountMapDetails({ payload }: any) {
	try {
		const key = 'GetAccountMapDetailsKey';
		const { branchID, companyID, databaseName, infogID, userAccessBranchID, userID } = payload;
		const jsonData = {
			BranchID: branchID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogID: infogID,
			UserAccessBranchID: userAccessBranchID,
			UserID: userID,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(getAccountMappingDetailsService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAccountMapDetailsFailure(responseData.data));
		} else {
			yield put(getAccountMapDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAccountMapDetailsFailure(error));
	}
}

export function* resetAccountMapDetailsResponse() {
	yield put(getAccountMapDetailsResponseChanged());
}

export function* onAccountMapDetails() {
	yield takeLatest(AccountMapActionTypes.ACCOUNT_MAP_DETAILS_START, getAccountMapDetails);
}

export function* onAccountMapDetailsResponseReset() {
	yield takeLatest(
		AccountMapActionTypes.ACCOUNT_MAP_DETAILS_RESPONSE_RESET,
		resetAccountMapDetailsResponse,
	);
}
/** ***************** GET ACCOUNT MAPPING DETAILS END *********************** */

/** ***************** UPDATE ACCOUNT MAPPING DETAILS START *********************** */
export function* updateAccountMapDetails({ payload }: any) {
	try {
		const key = 'UpdateAccountMapDetailsKey';
		const { accountMappingArr, branchID, companyID, databaseName, infogID, userName, userID } =
			payload;
		const jsonData = {
			AccountMappingArr: accountMappingArr,
			BranchID: branchID,
			CompanyID: companyID,
			DatabaseName: databaseName,
			InfogID: infogID,
			UserName: userName,
			UserID: userID,
		};

		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(updateAccountMappingDetailsService, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAccountMapDetailsFailure(responseData.data));
		} else {
			yield put(updateAccountMapDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAccountMapDetailsFailure(error));
	}
}

export function* resetUpdateAccountMapDetailsResponse() {
	yield put(updateAccountMapDetailsResponseChanged());
}

export function* onUpdateAccountMapDetails() {
	yield takeLatest(
		AccountMapActionTypes.UPDATE_ACCOUNT_MAP_DETAILS_START,
		updateAccountMapDetails,
	);
}

export function* onUpdateAccountMapDetailsResponseReset() {
	yield takeLatest(
		AccountMapActionTypes.ACCOUNT_MAP_DETAILS_RESPONSE_RESET,
		resetUpdateAccountMapDetailsResponse,
	);
}
/** ***************** UPDATE ACCOUNT MAPPING DETAILS END *********************** */

export function* accountMapDetailsSaga() {
	yield all([
		// FETCH ACCOUNT MAP DETAILS
		call(onAccountMapDetails),
		call(onAccountMapDetailsResponseReset),
		// UPDATE ACCOUNT MAP DETAILS
		call(onUpdateAccountMapDetails),
		call(onUpdateAccountMapDetailsResponseReset),
	]);
}
